import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./Menus.css";

const menuData = [
  {
    key: "westernMenu",
    image: "/menu_bg/western-menu.png",
    link: "/pdf/western-menu.pdf"
  },
  {
    key: "canapeMenu",
    image: "/menu_bg/canape-menu.png",
    link: "/pdf/canape-menu.pdf"
  },
  {
    key: "chineseMenu",
    image: "/menu_bg/chinese-menu.png",
    link: "/pdf/chinese-menu.pdf"
  }
];

const Menus = () => {
  const { t } = useTranslation();

  return (
    <Container id="menus" className="py-5" data-aos="fade-up">
      <h2 className="section-title text-center my-5">
        {t('ourMenus')}
        <div className="underline"></div>
      </h2>
      <Row className="g-4">
        {menuData.map((menu, idx) => (
          <Col
            md={4}
            key={idx}
            data-aos="fade-up"
            data-aos-delay={idx * 100} // 0ms, 100ms, 200ms
          >
            <div
              className="menu-banner position-relative overflow-hidden rounded-3"
              style={{ backgroundImage: `url(${menu.image})` }}
            >
              <div className="menu-overlay d-flex flex-column justify-content-center align-items-center text-white">
                <h3 className="mb-3">{t(menu.key)}</h3>
                <Button
                  variant="outline-light"
                  href={menu.link}
                  target="_blank"
                  className="fw-semibold px-4 py-2 border-2 custom-menu-btn"
                >
                  {t('viewPdf')}
                </Button>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Menus;